import { Link, type LinkProps } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { buttonStyles, type ButtonVariantProps } from './button-styles';

export interface ButtonLinkProps extends LinkProps, ButtonVariantProps {
  ref?: React.Ref<HTMLAnchorElement>;
}

export function ButtonLink({ className, variant, size, ref, ...props }: ButtonLinkProps) {
  return <Link ref={ref} className={cn(buttonStyles({ variant, size }), className)} {...props} />;
}

ButtonLink.displayName = 'ButtonLink';
